"use strict";

import Vue from 'vue';

/**
 * 友盟统计
 * 
 * @namespace
 */

let umeng = {
    eventId : {
        KCG_GLDBZH : 'KCG-GLDBZH',//开存管-关联担保账户按钮
        JK01 : 'JK01',//借款完成页
        HK00 : 'HK00',//还款页
        HK_FZ : 'HK-FZ'//还款-复制按钮
    }
}

const Plugin = {
    install: function (Vue) {
        Vue.$umeng = umeng;
        window.$umeng = umeng;
        Object.defineProperty(Vue.prototype, '$umeng', {
            value: umeng
        });
    }
};

Vue.use(Plugin);

export default umeng;